import React from "react";
//import { HashRouter as  BrowserRouter, Routes, Route } from 'react-router-dom';
import { HashRouter as BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts";
import { WebRouter } from "./router/WebRouter";
import { AdminRouter } from "./router/AdminRouter";
import { AssistanceRouter } from "./router/AssistanceRouter";
import { AssistanceRouterPublic } from "./router/AssistanceRouterPublic";
import { Assistance3dRouter } from "./router/Assistance3dRouter";
import { AuthInstitutionRouter } from "./router/AuthInstitutions";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Rutas principales del sitio web */}
          <Route path="/*" element={<WebRouter />} />

          <Route path="/login/*" element={<AuthInstitutionRouter />} />
          {/* Rutas del administrador */}
          <Route path="/admin/*" element={<AdminRouter />} />

          {/* Rutas de asistencia */}
          <Route path="/assistanceChat/*" element={<AssistanceRouter />} />

          {/* Rutas de asistencia */}
          <Route
            path="/assistancechatpublic/*"
            element={<AssistanceRouterPublic />}
          />

          {/* Rutas de asistencia */}
          <Route path="/assistanceChat3d/*" element={<Assistance3dRouter />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
